/** Serializa para localStorage (Postgres pode devolver bigint, que JSON.stringify não aceita). */
export function serializeForStorage(value: unknown): string {
    return JSON.stringify(value, (_key, v) => (typeof v === 'bigint' ? v.toString() : v));
}

export function readPersistedJson<T>(key: string): T | null {
    try {
        const raw = localStorage.getItem(key);
        if (!raw) return null;
        return JSON.parse(raw) as T;
    } catch {
        localStorage.removeItem(key);
        return null;
    }
}

export const LAST_TURISTA_EMAIL_KEY = 'facilita_last_turista_email';
export const LAST_MERCHANT_EMAIL_KEY = 'facilita_last_merchant_email';
